import React from 'react';
import { useField } from 'formik';

export const AppRadioField = ({ options, textMuted, isReadOnly = false, flex, labelStyles = {}, ...props }) => {
    const [field, meta] = useField(props);

    return (

        <>
            {
                options.map((option, index) => (

                    <div className={props.containerClass}>
                        <input
                            key={index}
                            type="radio"
                            id={option.value}
                            {...field}  
                            {...props}
                            // onChange={(e) => {
                            //     if (isReadOnly) {
                            //         e.preventDefault();
                            //         e.stopPropagation();
                            //         return;
                            //     }
                            //     // else allow formik to handle change
                            // }}
                            value={option.value}
                            checked={field.value === option.value}
                        />

                        <label className={textMuted && "text-muted"} style={{ marginLeft: "8px", ...labelStyles }}>{option.label || option.name}</label>
                    </div>

                ))
            }
            {
                meta.touched && meta.error ? (
                    <div className="text-danger">{meta.error}</div>
                ) : null
            }
        </>
    );
};
